import asapCondensed from './fonts/AsapCondensed-SemiBold.ttf';

const style = document.createElement('style');
style.innerHTML = `
  @font-face {
    font-family: "AsapCondensed";
    src: url(${asapCondensed}) format("truetype");
    font-weight: 600;
    font-style: normal;
  }
`;
document.head.appendChild(style);
